<template lang="pug">
div.wrap-module-asset-preview.relative.overflow-hidden.rounded
  div.wrap-header.absolute.w-full.l0.t0
    HeaderModalWindow(:label="asset.name" @closeModalWindow="$emit('closeModalWindow')")
  div(ref="assetPreviewContent").asset-preview-content.relative.overflow-scroll
    div.wrap-main-visual.mb8
      ItemAssetModelPreviewer(v-if="isPlaying" :asset="asset")
      div(v-if="!isPlaying").wrap-img.f.fh.w-full.h-full
        img(:src="asset.mainImg").object-fit-cover.h-full
        div(v-if="showPlayIcon").overlay.f.fh.w-full.h-full
          div.icon-play.px12.py12.circle.cursor-pointer
            v-icon(@click="isPlaying = true" dark) mdi-play
      div(v-if="!canNotBeAdded"
        @click="addSelectedAsset(asset.id)" :class="{'active': isSelected}"
        ).wrap-check-icon.absolute.t12.r12.f.fm.cursor-pointer.px8.py3.rounded
        span.btn-select-asset.mr4.pt1.bold {{labelBtnSelect}}
        v-icon(v-if="assetIdsToAdd.includes(asset.id)"
          :color="pallete.$active_color") mdi-check-circle
        v-icon(v-else dark) mdi-checkbox-blank-circle-outline
      div(v-else).wrap-cancel-icon.absolute.t12.r12.f.fm.cursor-pointer.px8.py3.rounded
        v-icon(dark) mdi-cancel

    div.wrap-head.mb8.pb8
      div.wrap-name.f.flex-between.mb8
        div.f.mr8
          span.fz20.bold.mb4.mr6.line-clamp-3 {{asset.name}}
            | #[v-icon(@click="onOpenInNew").pl4.pb3.cursor-pointer mdi-open-in-new]
        div.wrap-follow-like
          div.f.fm
            div.mr6
              ItemBtnFollowAsset(v-if="asset && user"
                :asset="asset" :me="user")
            ItemAssetFavorite(:asset="asset" :me="user")
      div.wrap-tags.f.flex-wrap.mb4
        span(v-for="tag in asset.tags"
          @click.stop="onTag(tag)"
          ).tag.fz14.px8.py4.mr8.mb8.rounded.cursor-pointer {{'#' + tag}}
      span.fz14.block {{asset.about}}
    div(v-if="childAssets[0]").wrap-child-asset.pt18.pb8
      span.label.fz14.bold.mb4 サブアセット
      div.f.flex-wrap
        ItemModalAssetCardToAdd(v-for="asset in childAssets"
          :asset="asset" :user="user"
          :assetIdsToAdd="assetIdsToAdd" :selfRatings="selfRatings"
          isInPreviewWindow
          :key="`modal-${asset.id}`"
          @addSelectedAsset="addSelectedAsset" @onTag="onTag"
          @changePreviewingAsset="changePreviewingAsset")
    div(v-if="parentAssets[0]").wrap-parent-asset.pt18.pb8
      span.label.fz14.bold.mb4 メインアセット
      div.f.flex-wrap
        ItemModalAssetCardToAdd(v-for="asset in parentAssets"
          :asset="asset" :user="user"
          :assetIdsToAdd="assetIdsToAdd" :selfRatings="selfRatings"
          isInPreviewWindow
          :key="`modal-${asset.id}`"
          @addSelectedAsset="addSelectedAsset" @onTag="onTag"
          @changePreviewingAsset="changePreviewingAsset")
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$modal_header_height: 45px;
.wrap-module-asset-preview {
  padding-top: $modal_header_height;
  background: $primary_bg_color;
  max-width: 96vw;
  min-width: 60vw;
  max-height: 92vh;
  cursor: auto;
  .asset-preview-content {
    max-height: calc(92vh - #{$modal_header_height});
    .wrap-main-visual {
      min-width: 80vw;
      height: 60vh;
      .wrap-img {
        position: relative;
        .overlay {
          position: absolute;
          left: 0; top: 0;
          .icon-play {
            background: rgba(0, 0, 0, 0.4);
          }
        }
      }
      .wrap-check-icon, .wrap-cancel-icon {
        background: $overlay_color;
        .btn-select-asset {
          color: $dark_primary_text_color;
          &.active {
            color: $active_color;
          }
        }
      }
    }
    .wrap-head, .wrap-child-asset, .wrap-parent-asset {
      margin: 0 auto;
      width: $base_width_percent;
      max-width: $base_max_width_px;
      .wrap-tags {
        .tag {
          border: $basic_border;
        }
      }
    }
    .wrap-child-asset, .wrap-parent-asset {
      border-top: $basic_border;
    }
  }

  @media only screen and (max-width: $responsive_sp_width) {
    .asset-preview-content {
      .wrap-head {
        .wrap-name {
          display: block;
          .wrap-follow-like {
            margin-top: 8px;
            margin-bottom: 12px;
          }
        }
      }
    }
  }
}
</style>

<script>
import { domain } from '@/components/utils/config'
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth, mapActions: mapActionsAuth } = createNamespacedHelpers('auth')
import HeaderModalWindow from '@/components/shared/HeaderModalWindow'
import ItemAssetModelPreviewer from '@/components/item/ItemAssetModelPreviewer'
import ItemModalAssetCardToAdd from '@/components/item/studio/ItemModalAssetCardToAdd'
import ItemBtnFollowAsset from '@/components/item/ItemBtnFollowAsset'
import ItemAssetFavorite from '@/components/item/ItemAssetFavorite'
// TODO: 親アセット一覧
export default {
  components: {
    HeaderModalWindow,
    ItemAssetModelPreviewer, ItemModalAssetCardToAdd,
    ItemBtnFollowAsset, ItemAssetFavorite
  },
  props: {
    asset: {
      type: Object,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    assetIdsToAdd: {
      type: Array,
      required: true
    },
    selfRatings: {
      type: Object,
      required: true
    },
    canNotBeAdded: {
      type: Boolean,
      requred: true
    }
  },
  data () {
    return {
      childAssets: [],
      parentAssets: [],
      isPlaying: false
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    showPlayIcon () {
      return ['actor', '3d_stage', '3d_object'].includes(this.asset.type)
    },
    isSelected () {
      return this.assetIdsToAdd.includes(this.asset.id)
    },
    labelBtnSelect () {
      return this.isSelected ? '選択済み' : 'アセットを選択'
    },
    assetURL () {
      return `${domain}/asset/${this.asset.id}`
    }
  },
  watch: {
    asset () {
      this.initializePreview()
    }
  },
  mounted () {
    this.initializePreview()
  },
  methods: {
    async initializePreview () {
      this.childAssets = await database.assetCollection()
        .getChildAssets({ parentAssetId: this.asset.id })

      this.parentAssets = []
      if (this.asset.parentAsset && this.asset.parentAsset[0]) {
        this.parentAssets = await database.assetCollection()
          .getAssetsByIds(this.asset.parentAsset)
      }

      this.$refs.assetPreviewContent.scrollTop = 0
    },
    addSelectedAsset (assetId) {
      this.$emit('addSelectedAsset', assetId)
    },
    onOpenInNew () {
      window.open(this.assetURL, '_blank')
    },
    onTag (tag) {
      this.$emit('onTag', tag)
    },
    changePreviewingAsset (asset) {
      this.$emit('changePreviewingAsset', asset)
    }
  }
}
</script>
